import { Button } from "@chakra-ui/button";
import { Input, InputProps } from "@chakra-ui/input";
import { Box } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { useEffect, useState } from "react";

export interface InputSearchProps {
  onSearch: (q?: string) => void;
  defaultValue: string;
  placeholder?: string;
  maxW?: number | string;
  rounded?: string | number;
  inputProps?: InputProps;
}

function InputSearch({
  onSearch,
  defaultValue,
  placeholder = "Procurar",
  maxW = 350,
  rounded = "full",
  inputProps,
}: InputSearchProps) {
  const [search, update] = useState<string>();

  useEffect(() => {
    update(defaultValue);
  }, [defaultValue]);

  const handleEnder = (ev: any) => {
    if (ev.keyCode === 13) {
      onSearch(search);
    }
  };

  return (
    <>
      <Box maxW={maxW} w="100%" d="flex" flexDir="row" pos="relative">
        <Input
          value={search}
          onChange={(v) => update(v.target.value)}
          placeholder={placeholder}
          onKeyDown={(ev) => handleEnder(ev)}
          pr="48px"
          rounded={rounded}
          {...inputProps}
        />
        <Button
          right="4px"
          size="sm"
          top="4px"
          w="35px"
          pos="absolute"
          zIndex="1"
          ml="4px"
          rounded={rounded}
          bg={colors.primary}
          _hover={{
            bg: colors.primaryDark,
          }}
          _active={{
            bg: colors.primaryDark,
          }}
          color="white"
          onClick={() => onSearch(search)}
        >
          <i style={{ fontSize: 18 }} className="mdi mdi-magnify" />
        </Button>
      </Box>
    </>
  );
}

export default InputSearch;
